<template>
    <div class="container-fluid">
        <div class="page-title">
            <h4>Importer une liste d'outils</h4>
        </div>
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-block">
                        <div class="row relative">
                            <form id="shipping-form" class="width-100" @submit.prevent="import_systems">
                                <div id="rootwizard" class="form-wizard col-md-11 ml-auto mr-auto">
                                    <b-tabs pills v-model="tabIndex" nav-wrapper-class="nav-fill">
                                        <b-tab v-bind:disabled="tabIndex == 2 " @click="active">
                                            <template slot="title">
                                                <span class="step">1</span>
                                                <span class="title">Sélectionner un fichier</span>
                                            </template>
                                            <div class="form-group">
                                                <label>Choisissez un fichier Exel ou CSV à importer : </label>
                                                <b-form-file ref="fileinput" v-model="file" :state="Boolean(file)" accept=".xlsx, .xls, .csv" placeholder="Choisir votre fichier..."></b-form-file>
                                            </div>
                                            <!-- <div class="form-group">
                                                <label>Séparateur : </label>
                                                <select class="form-control">
                                                    <option value="," selected>Virgule</option>
                                                    <option value=";">Point-virgule</option>
                                                    <option value="\n">Tabulation</option>
                                                    <option value="|">Barre verticale</option>
                                                    <option value=":">Double point</option>
                                                </select>
                                            </div> -->
                                            <div class="form-check">
                                                <input class="form-check-input" type="checkbox"   v-model="first_column_header" id="first_header">
                                                <label class="form-check-label" for="first_header">
                                                    Utiliser la première ligne comme entête de fichier
                                                </label>
                                            </div>
                                        </b-tab>
                                        <b-tab  v-bind:disabled="file == '' || tabIndex == 2 || options_obligatory == '' " >
                                            <template slot="title">
                                                <span class="step">2</span>
                                                <span class="title">Sélectionner et vérifier les colonnes</span>
                                            </template>
                                            <p class="text-center font-weight-bold mb-5">Veuillez associer les colonnes de votre fichier aux données attendues</p>
                                            <div class="row">
                                                <div class="col-md-5">
                                                    <div class="form-group row">
                                                        <label class="col col-form-label text-right">Code<span class="text-danger">*</span> : </label>
                                                        <b-form-select v-model="columns.code" :options="options_obligatory" class="col-md-8" required>
                                                        </b-form-select>
                                                    </div>
                                                    <div class="form-group row">
                                                        <label class="col col-form-label text-right">Nom<span class="text-danger">*</span> : </label>
                                                        <b-form-select v-model="columns.name" :options="options_obligatory" class="col-md-8" required>
                                                        </b-form-select>
                                                    </div>
                                                </div>
                                                <div class="offset-md-1 col-md-6">
                                                    <div class="form-group row">
                                                        <label class="col col-form-label text-right">Description : </label>
                                                        <b-form-select v-model="columns.description" :options="options" class="col-md-8" required>
                                                        </b-form-select>
                                                    </div>
                                                </div>
                                            </div>
                                        </b-tab>
                                        <b-tab v-bind:disabled="!import_success">
                                            <template slot="title">
                                                <span class="step">3</span>
                                                <span class="title">Confirmation</span>
                                            </template>
                                            <div class="col-md-6 mr-auto ml-auto">
                                                <div class="text-center">
                                                    <h2>Félicitation!</h2>
                                                    <p>Votre liste d'outils à été bien importée</p>
                                                    <router-link to="/systems/index" class="btn btn-info btn-inverse btn-lg">
                                                        Voir tous les outils
                                                    </router-link>
                                                </div>
                                            </div>
                                        </b-tab>
                                    </b-tabs>

                                    <div id="bar" class="progress progress-info" style="width: 65%">
                                        <div class="progress-bar" role="progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100" style="width: 0%;"></div>
                                    </div>

                                    <div class="mt-2">
                                        <button type="button" class="btn btn-default button-previous btn-rounded" @click="clear(tabIndex--) "  v-show="tabIndex == 1">Précédent</button>
                                        <button type="button" class="btn btn-primary button-next pull-right btn-rounded" @click="next" v-bind:disabled="file == ''" v-show="tabIndex == 0">Suivant</button>
                                        <button type="submit"
                                                class="btn btn-primary button-next pull-right btn-rounded"
                                                v-show="tabIndex == 1">Importer</button>
                                        <button type="button"
                                                @click="cancel_step2"
                                                class="btn btn-danger pull-right btn-rounded"
                                                v-show="tabIndex == 1">Annuler</button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import api from "../../config/_api";
    import XLSX from "xlsx";

    export default {
        name: "Import",
        data () {
            return {
                tabIndex: 0,
                file: "",
                startData: 1,
                first_column_header: true,
                data: {},
                columns: {
                    code: null,
                    name: null,
                    description: null
                },
                options_obligatory: [],
                options: [],
                import_success: false
            }
        },
        methods: {

            import_systems() {

                let data = {
                    data: this.data,
                    columns: this.columns,
                    first_column_header: this.first_column_header
                };

                var self = this;

                var first_line_to_check = data.first_column_header ? 1 : 0;
                // eslint-disable-next-line
                var interdit = /[&~#'{[\|`\\^@)\]°}=+$~"^¨«»³€†%©®ª()ß*µ¿%+‡£¤¨±¤×÷²ù%*µ!§:/;\.,\?<>]/ig;
                var normally_cheched_collumns=[data.columns.code,data.columns.name,data.columns.description]

                for( var n = first_line_to_check; n < data.data.length; n++){ 
                    if (self.data[n][data.columns.code] == undefined ){
                        alert ("Attention, le fichier n'est pas conforme");
                        return  window.location.reload();
                    }
                    if (self.data[n][data.columns.name] == undefined ){
                        alert ("Attention, le fichier n'est pas conforme");
                        return  window.location.reload();
                    }
                    var  y= [self.data[n]];
                    for( var s = 0; s <y.length; s++){
                        for(var p = 0; p <normally_cheched_collumns.length; p++){
                            var  h =  y[s][normally_cheched_collumns[p]];
                            if(h != undefined){
                                var chaine = h.trim();  
                                if((chaine.length > 255) || 
                                    interdit.test(chaine) || 
                                    (chaine == "") 
                                ){
                                    alert ("Attention, le fichier n'est pas conforme");
                                    return  window.location.reload();
                                }
                            }
                        }
                    }    
                }

                this.axios({url: api.url + 'systems/import?structure_id=' + this.$store.getters.structure_id, data: data, method: 'POST' })
                    .then(resp => {
                        if(resp.status <400){
                            self.import_success = true;
                            setTimeout(function () {
                                self.tabIndex++;
                            }, 50);
                        }
                    })
                 /*   .catch(err => {
                        console.log(err);
                    });*/
            },
            cancel_step2() {
                this.columns = {
                    code: null,
                    name: null,
                    description: null
                };
            },
            clear(){
            this.$refs.fileinput.reset();
             this.options_obligatory ='';
              },
              active() {
               this.options_obligatory ='';
               },
            next() {
                var url = window.URL.createObjectURL(this.file);
                var self = this;
                self.columns = {
                    code: null,
                    name: null,
                    description: null
                };
                self.options_obligatory = [{ value: null, text: 'Veuillez sélectionner une colonne' }];
                self.options = [{ value: null, text: 'Veuillez sélectionner une colonne' }, {value: -1, text: 'Aucune colonne correspondante'}];
                this.axios(url, {responseType:'arraybuffer'})/*.catch(function(err) {
                    console.log("Bug à la récupération du fichier");
                })*/.then(function(res) {
                    var data = new Uint8Array(res.data);
                    var workbook = XLSX.read(data, {type:"array"});
                    return workbook;
                })/*.catch(function(err) {
                })*/.then(function(workbook) {
                    self.data = XLSX.utils.sheet_to_json(workbook.Sheets[workbook.SheetNames[0]], {header:1, raw:true});
                     
                    var i = self.first_column_header ? 1 : 0;
                    // eslint-disable-next-line
                    var interdit = /[&~#'{[\|`\\^@)\]°}=+$~"^¨«»³€†%©®ª()ß*µ¿%+‡£¤¨±¤×÷²ù%*µ!§:/;\.,\?<>]/ig;

                    for(var j = 0; j < self.data[0].length; j++) {
                        var text = "Colonne n°" + j + " : ";
                        for (var t = i; t < self.data.length; t++) {
                            if(interdit.test(self.data[t][j])){
                                alert ("Attention, le fichier contient des caractères interdits\n/[&~#'{[|`\\^)]°}=$~\"^¨«»³€†%©®ª()ß*µ¿%+‡£¤¨±¤×÷²ù%*µ!§:/;,?<>]");
                                return  window.location.reload();
                            }
                            text = text + (self.data[t][j] != undefined && self.data[t][j] != "" ? self.data[t][j] : "indéfini") + (t != (self.data.length-1) ? ", " : "");
                            if(self.data[t][j] == undefined){
                                self.data[t][j] = null;
                            }
                        }
                        var option = {
                            value : j,
                            text: text
                        };
                        self.options_obligatory.push(option);
                        self.options.push(option);
                    }
                    self.tabIndex++;
                });
            }
        }
    }
</script>